import { render, staticRenderFns } from "./ProductsInfo.vue?vue&type=template&id=17ca6c2f&scoped=true&"
import script from "./ProductsInfo.vue?vue&type=script&lang=js&"
export * from "./ProductsInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductsInfo.vue?vue&type=style&index=0&id=17ca6c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca6c2f",
  null
  
)

export default component.exports